module.exports = __webpack_public_path__ + "img/logo.864a0909.png";